var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 44,
    viewBox: "0 0 50 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 42.6667,
    transform: "translate(0 0.441528)",
    fill: "#35AFA3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7632 17.4707L29.3038 21.0115L21.0406 29.2749H17.5V25.7333L25.7632 17.4707ZM26.9434 16.2897L28.7137 14.5193C28.8702 14.3628 29.0825 14.2749 29.3038 14.2749C29.5252 14.2749 29.7374 14.3628 29.8939 14.5193L32.2552 16.8798C32.3328 16.9573 32.3944 17.0494 32.4364 17.1507C32.4784 17.252 32.5 17.3606 32.5 17.4703C32.5 17.58 32.4784 17.6886 32.4364 17.79C32.3944 17.8913 32.3328 17.9833 32.2552 18.0609L30.484 19.8312L26.9434 16.2897Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminEdit);
export default __webpack_public_path__ + "static/media/adminEdit.43f1f3e1a3076b661d1772965df60881.svg";
export { ForwardRef as ReactComponent };